module.exports = "<div class=\"q-overflow-auto clearfix\"> <div class=scheduler-component-wrapper> <table> <thead> <tr> {%= availDates %} </tr> </thead> <tbody> <tr> {%= availTimes %} </tr> </tbody> </table> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/components/scheduler/html/baseTemplate.html
// module id = 1169
// module chunks = 1